export default __webpack_public_path__ + "static/media/rede_pos.050eb0f2.png";